var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.item[_vm.fieldMap.children] &&
    _vm.item[_vm.fieldMap.children].length
    ? _c(
        "el-submenu",
        { attrs: { index: _vm.item[_vm.fieldMap.id] } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { class: _vm.picon }),
            _c("span", [_vm._v(_vm._s(_vm.item[_vm.fieldMap.title]))]),
          ]),
          _vm._l(_vm.item[_vm.fieldMap.children], function (child) {
            return _c("menu-item", {
              key: child[_vm.fieldMap.id],
              attrs: {
                item: child,
                picon: _vm.picon,
                cicon: _vm.cicon,
                "field-map": _vm.fieldMap,
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("click", $event)
                },
              },
            })
          }),
        ],
        2
      )
    : _c(
        "el-menu-item",
        {
          attrs: { index: _vm.item[_vm.fieldMap.id] },
          on: {
            click: function ($event) {
              return _vm.$emit("click", _vm.item)
            },
          },
        },
        [
          _c("i", { class: _vm.cicon }),
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.item[_vm.fieldMap.title])),
          ]),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }